import { render, staticRenderFns } from "./Limit.vue?vue&type=template&id=003e723f"
import script from "./Limit.vue?vue&type=script&lang=ts"
export * from "./Limit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports